"use strict";
/****************************************************
 * Audit Information Platform Component
 * 数值录入参照项目组件
 * 2020-08
 * Sunny <tufpsj@yonyou.com>
 ****************************************************/
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
//----- Global ------
var React = require("react");
//----- iUAP ------
var tinper_bee_1 = require("tinper-bee");
//----- AIP -----
var RefItem_1 = require("./RefItem");
var Message_1 = require("./Message");
require("../style/RefItems.css");
var utils_1 = require("../utils");
/**
 * 更简单的数值类型的参照项
 * 数值显示组件，可输入且会验证输入，与NumberRef的区别在于这个对外展示的如同Text组件，没有+/-数值按钮
 */
var NumberPlainRef = /** @class */ (function (_super) {
    __extends(NumberPlainRef, _super);
    function NumberPlainRef() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            value: "",
            defaultValue: _this.props.defaultValue,
        };
        /**
         * 重置值 **override**
         * @function
         */
        _this.clear = function () {
            _this.setState({
                defaultValue: '',
                value: ''
            }, function () { });
        };
        /**
         * 值发生变化调用(包含数值录入验证)
         * @function
         * @param {string} value
         */
        _this._onChange = function (value) {
            if (/^(-)?(\d|\.)*$/.test(value)) {
                _this.setState({ value: value }, function () {
                    _this.refItemValueChange(value);
                });
            }
            else {
                Message_1.default.showMessage((0, utils_1.getTranslate)(null, '只能输入数值'));
            }
        };
        /**
         * 获取数据的方法，会被调度系统触发 ** 每个子类必须实现 **
         * @function
         *
         * @param {StringStringMap} params 依赖的参数对象
         * @param {string} defaultValue ***可选*** 默认值，如果有默认值，需要在`loadData`后设置设置关联值，再调用`refItemValueChange`通知调度器
         */
        _this.loadData = function (params, defaultValue) {
            if (defaultValue) {
                _this.setDefaultValue(defaultValue);
                _this.refItemValueChange(defaultValue);
            }
        };
        return _this;
    }
    NumberPlainRef.prototype.render = function () {
        return (React.createElement("div", { className: 'numberref', style: { width: this.props.width || 120, } },
            React.createElement(tinper_bee_1.FormControl, { value: this.state.value, onChange: this._onChange })));
    };
    return NumberPlainRef;
}(RefItem_1.default));
exports.default = NumberPlainRef;
